export default __webpack_public_path__ + "static/media/GroupNotes.dc34b361.svg";